import db from '@klinx/utils/localstorage';

export default {
  namespaced: true,
  state: {
    websocket: '',
    refreshToken: db.get('REFRESH_TOKEN'),
    token: db.get('TOKEN', ''),
    appList: db.get('APPLIST', []) || [],
    appId: db.get('APPID', ''),
    tId: db.get('TID', ''),
    uId: db.get('UID', ''),
    tenant: db.get('TENANT', ''),
    tenantName: db.get('TENANT_NAME', ''),
    expireTime: db.get('EXPIRE_TIME', 0),
    user: db.get('USER') || {},
    password: db.get('PWD'),
    permissions: db.get('PERMISSIONS') || [],
    authorityResource: db.get('AUTHORITY_RESOURCE') || { 'enabled': true, 'caseSensitive': false, 'resourceList': [], 'roleList': [] },
    // 当前应用菜单路由，优先取当前页面缓存，再取本地浏览器缓存
    routes: JSON.parse(window.sessionStorage.getItem('USER_ROUTER') || JSON.stringify(db.get('USER_ROUTER') || [])),
    currentRoutes: db.get('CURRENT_ROUTER') || [],
    menuActiveIndex: db.get('MENU_ACTIVE_INDEX') || 0,
    tenantsList: db.get('TENANTS_LIST') || [],
    notify: db.get('NOTIFY') || {},
    // 当前应用信息，优先取当前页面缓存，再取本地浏览器缓存
    currentApp: JSON.parse(window.sessionStorage.getItem('CURRENTAPP') || JSON.stringify(db.get('CURRENTAPP') || {})),
    msgData: {},
    speakMsgList: db.get('SPEAK_MSGLIST', [])
  },
  mutations: {
    SET_CURRENT_APP(state, app) {
      db.save('CURRENTAPP', { ...app, lang: db.get('LANGUAGE') });
      window.sessionStorage.setItem('CURRENTAPP', JSON.stringify({ ...app, lang: db.get('LANGUAGE') }));
      state.currentApp = { ...app, lang: db.get('LANGUAGE') };
    },
    // websocket
    websocket(state, val) {
      state.websocket = val;
    },
    // 保存租户code
    setTenant(state, val) {
      db.save('TENANT', val);
      state.tenant = val;
    },
    // 保存租户名称
    setTenantName(state, val) {
      db.save('TENANT_NAME', val);
      state.tenantName = val;
    },
    setAppId(state, val) {
      db.save('APPID', val);
      state.appId = val;
    },
    setAppList(state, list) {
      db.save('APPLIST', list);
      state.appList = list;
    },
    setTId(state, val) {
      db.save('TID', val);
      state.tId = val;
    },
    setUId(state, val) {
      db.save('UID', val);
      state.uId = val;
    },
    setRefreshToken(state, val) {
      db.save('REFRESH_TOKEN', val);
      state.refreshToken = val;
    },
    setToken(state, val) {
      db.save('TOKEN', val);
      state.token = val;
    },
    setExpireTime(state, val) {
      db.save('EXPIRE_TIME', val);
      state.expireTime = val;
    },
    setUser(state, val) {
      db.save('USER', val);
      state.user = val;
    },
    setPwd(state, val) {
      db.save('PWD', val);
      state.password = val;
    },
    setPermissions(state, val) {
      db.save('PERMISSIONS', val);
      state.permissions = val;
    },
    setAuthorityResource(state, val) {
      db.save('AUTHORITY_RESOURCE', val);
      state.authorityResource = val;
    },
    setRoutes(state, val) {
      db.save('USER_ROUTER', val);
      window.sessionStorage.setItem('USER_ROUTER', JSON.stringify(val));
      state.routes = val;
    },
    removeRoutes(state) {
      db.remove('USER_ROUTER');
      window.sessionStorage.setItem('USER_ROUTER', JSON.stringify([]));
      state.routes = [];
    },
    setCurrentRoutes(state, val) {
      db.save('CURRENT_ROUTER', val);
      state.currentRoutes = val;
    },
    removeCurrentRoutes(state) {
      db.remove('CURRENT_ROUTER');
      state.currentRoutes = '';
    },
    setActiveIndex(state, val) {
      db.save('MENU_ACTIVE_INDEX', val);
      state.menuActiveIndex = val;
      window.localStorage.setItem('activeIndex', val);
    },
    setTenantsList(state, val) {
      db.save('TENANTS_LIST', val);
      state.tenantsList = val;
    },
    setNotify(state, val) {
      db.save('NOTIFY', val);
      state.notify = val;
    },
    SET_MSG_DATA(state, msgData) {
      state.msgData = null;
      state.msgData = { ...msgData };
    },
    setSpeakMsgList(state, List) {
      db.save('SPEAK_MSGLIST', List);
      state.speakMsgList = List;
    }
  }
};
